import ButtonComponent from "@components/Theme/Button/Button"
import Typography, {
	Size,
	Variant,
} from "@components/WebsiteRevamp/Typography/Typography"
import {AdvancedSideAssetMainContent} from "@hooks/WorkWithJson/GetComponentDataByKey/GetComponentDataByKeyTypes"
import React, {useState} from "react"

import styles from "./ExpandedSecondary.module.scss"
import ExpandedSecondaryAnimation from "./ExpandedSecondaryAnimation"

type Props = {
	data: AdvancedSideAssetMainContent[]
	withAspectRation?: boolean
}

const ExpandedSecondary = (props: Props) => {
	const [showItem, setShowItem] = useState<number>(0)

	const changeShowedItem = (id: number): void => {
		setShowItem(id)
	}

	return (
		<div className={`${styles.container}`}>
			<div className={styles.buttonsContainer}>
				{props.data?.map(
					(element: AdvancedSideAssetMainContent, index: number) => {
						return (
							<React.Fragment
								key={`list-item-${element.title}-${index}`}
							>
								<ButtonComponent
									buttonType={"expandedSecondary"}
									className={styles.button}
									expandActive={showItem === index}
									expandUnactive={showItem !== index}
									onClick={() => changeShowedItem(index)}
								>
									<>
										<Typography
											as={"h3"}
											content={element.title}
											noPadding={showItem !== index}
											size={Size.M}
											variant={Variant.Title}
										/>
										<Typography
											className={
												showItem === index
													? styles.visible
													: styles.hidden
											}
											content={element.subtitle}
											// fontWeight={400}
											size={Size.XS}
											variant={Variant.Description}
										/>
									</>
								</ButtonComponent>
								<div className={styles.contentContainerMobile}>
									<ExpandedSecondaryAnimation
										key={index}
										element={element}
										show={showItem === index}
										withAspectRation={
											props.withAspectRation
										}
									/>
								</div>
							</React.Fragment>
						)
					},
				)}
			</div>

			<div className={styles.contentContainer}>
				{props.data?.map((item, index) => {
					return (
						<ExpandedSecondaryAnimation
							key={`${item.title}-${index}`}
							element={item}
							show={showItem === index}
							withAspectRation={props.withAspectRation}
						/>
					)
				})}
			</div>
		</div>
	)
}

export default ExpandedSecondary
